// lazy-picture.js
// Handles lazy loading for <picture> elements with <source data-srcset> + <img data-src>
// Works with your existing Defer.js setup.

(function () {
  document.addEventListener("DOMContentLoaded", function () {
    // Target any <img> with .lazyload inside picture
    const lazyImages = document.querySelectorAll("picture img.lazyload");

    const loadPicture = (entry, observer) => {
      const picture = entry.target.closest("picture");
      if (!picture) return;

      // Restore <source> elements
      picture.querySelectorAll("source[data-srcset]").forEach(source => {
        source.setAttribute("srcset", source.getAttribute("data-srcset"));
        source.removeAttribute("data-srcset");
      });

      // Restore <img> element
      const img = picture.querySelector("img[data-src]");
      if (img) {
        img.setAttribute("src", img.getAttribute("data-src"));
        img.removeAttribute("data-src");
      }

      observer.unobserve(entry.target);
    };

    // Create the observer
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) loadPicture(entry, observer);
        });
      },
      {
        rootMargin: "150px 0px", // preload slightly before visible
        threshold: 0.01
      }
    );

    // Observe each lazy <img>
    lazyImages.forEach(img => observer.observe(img));
  });
})();